import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const masterDataTypeService = {
  fetchAllWithoutPagination: async () => {
    const response = await axiosInstance.get('/master-data-type')
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/master-data-type/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/master-data-type/' + id)
    return response.data
  },
  getByName: async (name) => {
    const response = await axiosInstance.get(`/master-data-type/find/${name}`)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/master-data-type', data )
    return response.data
  },
  storeAttribute: async (id, data) => {
    const response = await axiosInstance.post(`/master-data-type/${id}/store-attribute`, data )
    return response.data
  },
  update: async (data) => {
    const response = await axiosInstance.put(`/master-data-type/${data.id}`, data)
    return response.data
  },
  updateAttribute: async (data) => {
    const response = await axiosInstance.put(`/master-data-type/${data.id}/update-attribute`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/master-data-type/${id}`)
    return response.data
  },
  deleteAttribute: async (id) => {
    const response = await axiosInstance.delete(`/master-data-type/${id}/attribute`)
    return response.data
  },
  deleteAttributeOption: async (id) => {
    const response = await axiosInstance.delete(`/master-data-type/${id}/attribute-option`)
    return response.data
  },
}